/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  nameLabel: {
    id: 'channels.TabbedHeader.nameLabel',
    defaultMessage: 'Integration name'
  },
  defaultName: {
    id: 'channels.TabbedHeader.defaultName',
    defaultMessage: 'Default integration name'
  },
  nameRequired: {
    id: 'channels.TabbedHeader.nameRequired',
    defaultMessage: 'Name is required'
  },
  nameLengthError: {
    id: 'channels.TabbedHeader.nameLengthError',
    defaultMessage: 'Name has a max length of {length} characters'
  },
  icon: {
    id: 'channels.TabbedHeader.icon',
    defaultMessage: ' icon'
  },
  tabsLabel: {
    id: 'channels.TabbedHeader.tabsLabel',
    defaultMessage: '{tabLabel} configuration tabs'
  }
});
